import { render, staticRenderFns } from "./return_policy.vue?vue&type=template&id=273af593&"
import script from "./return_policy.vue?vue&type=script&lang=js&"
export * from "./return_policy.vue?vue&type=script&lang=js&"
import style0 from "./return_policy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports